export function getSchedulerSessionErrorPresentation(session) {
    const isFailure = session.status === "failed"
        || session.hasErrors === true
        || (session.jobs ?? []).some((job) => job.status === "failed");

    return {
        isFailure,
        showMessage: session.hasErrors === true || Boolean(session.errorMessage),
    };
}

export function getSchedulerJobErrorPresentation(job) {
    return {
        isFailure: job.status === "failed" || Boolean(job.failureMessage),
    };
}

